import { render, staticRenderFns } from "./testingletiant.vue?vue&type=template&id=5684aff6&scoped=true&"
import script from "./testingletiant.vue?vue&type=script&lang=js&"
export * from "./testingletiant.vue?vue&type=script&lang=js&"
import style0 from "./testingletiant.vue?vue&type=style&index=0&id=5684aff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684aff6",
  null
  
)

export default component.exports